/**
 * Global Imports
*/

import React, { useEffect, useContext } from 'react';

/**
 * Root Imports
*/

import { PageContext } from '~/components/PageProvider';
import { ShowRoleService } from '~/services/Role';

/**
 * Local Imports
*/

import { RoleContext } from '../../Providers/RoleProvider';
import { ResourceManage } from '../../Widgets/ResourceManage';

/**
 * Exports
*/

/**
 * 
 */
export function IndexRole(props) {
  /** Contexts **/
  
  const page = useContext(PageContext);
  
  /** Side-Effects **/

  useEffect(() => {
    handleMount();
  }, []);
  
  /** Event Handlers **/
  
  /**
   * 
   */
  const handleMount = () => {
    page.change({
      group: 'roles',
      breadcrumbs: 'Roles'
    });
  };
  
  /** Renderers **/

  /**
   * 
   */
  const renderIndex = () => (
    <div>Choose a role.</div>
  );
  
  /** Output **/
  
  return (
    <ResourceManage
      group='roles'
      context={ RoleContext }
      service={ ShowRoleService }
      renderIndex={ renderIndex }
    />
  );
}